/* eslint-disable react/destructuring-assignment -- Will make the code unnecessarily complex */
import "fullscreen-polyfill";
import { QueryClientProvider } from "@circle-react/providers/QueryClient";
import { VideoPlayer } from "@circle-react-shared/MediaPlayer/VideoPlayer";
import { useMediaConfig } from "@circle-react-shared/MediaPlayer/VideoPlayer/hooks/useMediaConfig";
import { useNewMediaPlayerEnabled } from "@circle-react-shared/MediaPlayer/hooks/useNewMediaPlayerEnabled";
import { ToastProvider } from "@circle-react-uikit/ToastV2";
import type { TranscriptsPlayerProps } from "./TranscriptsPlayerComponent";
import { TranscriptsPlayerComponent } from "./TranscriptsPlayerComponent";

export const TranscriptsPlayer = (props: TranscriptsPlayerProps) => {
  const isNewMediaPlayerEnabled = useNewMediaPlayerEnabled();
  const isVideoFile = props.type.toLowerCase().startsWith("video/");

  const { posterUrl, isDownloadable, mediaTranscriptId } = useMediaConfig({
    signedId: props.signedId,
    posterUrl: props.poster,
    isDownloadable: props.isDownloadable,
    mediaTranscriptId: props.mediaTranscriptId,
  });

  if (isVideoFile && isNewMediaPlayerEnabled)
    return (
      <VideoPlayer
        src={props.src}
        contentType={props.type}
        mediaTranscoding={props.mediaTranscoding}
        mediaTranscriptId={mediaTranscriptId}
        downloadUrl={props.downloadUrl}
        downloadable={isDownloadable}
        posterUrl={posterUrl}
        chaptersUrl={props.chaptersUrl}
        previewThumbnailsUrl={props.previewThumbnailsUrl}
        signedId={props.signedId}
        variants={props.variants}
        onProgress={props.onProgress}
        preload={props.preload}
      />
    );

  return (
    <QueryClientProvider>
      <ToastProvider>
        <TranscriptsPlayerComponent {...props} />
      </ToastProvider>
    </QueryClientProvider>
  );
};
